export default __webpack_public_path__ + "images/2fb39f87d5ce396c4cc9b29992fbcc99-home.jpg";